import { head, equals, slice } from 'ramda'

export const transformPhoneToForm = (phone?: string) => {
  if (!phone) return ''

  if (equals(head(phone), '1')) return slice(1, Infinity, phone)

  return phone
}
